import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from 'src/helpers/api/apiCore';

// api
import {
    creatReport as createReportApi,
    updateReport as updateReportApi,
    getAllReport as getAllReportApi,
    getReport as getReportApi,
    getValidateReport as getValidateReportApi,
    getAllServiceReport as getAllServiceReportApi,
    getAllSalesReport as getAllSalesReportApi,
    getObservationReport as getObservationReportApi,
} from './api';

// actions
import { reportApiResponseSuccess, reportApiResponseError } from './actions';

// constants
import { ReportActionTypes } from './constants';

type ReportData = {
    payload: any;
    type: string;
};

const api = new APICore();

/**
 * Add Report
 * @param {*} payload
 */
function* AddReport({ payload, type }: ReportData): SagaIterator {
    try {
        const response = yield call(createReportApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                reportApiResponseSuccess(
                    ReportActionTypes.ADD_REPORT,
                    data,
                    'Report has been created.',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while creating Report!`;
            if (message) msg = message;
            yield put(reportApiResponseSuccess(ReportActionTypes.ADD_REPORT, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(reportApiResponseError(ReportActionTypes.ADD_REPORT, [], error, 404, true, false));
    }
}

/**
 * Edit Report
 * @param {*} payload
 */
function* EditReport({ payload, type }: ReportData): SagaIterator {
    try {
        const response = yield call(updateReportApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                reportApiResponseSuccess(
                    ReportActionTypes.EDIT_REPORT,
                    data,
                    'Report Get Updated Successfully',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while edit Report!`;
            if (message) msg = message;
            yield put(reportApiResponseSuccess(ReportActionTypes.EDIT_REPORT, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(reportApiResponseError(ReportActionTypes.EDIT_REPORT, [], error, 404, true, false));
    }
}

/**
 * Fetch Report
 * @param {*} payload
 */
function* GetReport({ payload, type }: ReportData): SagaIterator {
    try {
        const response = yield call(getReportApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(reportApiResponseSuccess(ReportActionTypes.GET_REPORT, data, message, code, false, false));
        } else {
            let msg = `An error while getting Report!`;
            if (message) msg = message;
            yield put(reportApiResponseSuccess(ReportActionTypes.GET_REPORT, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(reportApiResponseError(ReportActionTypes.GET_REPORT, [], error, 404, true, false));
    }
}

/**
 * Fetch Reports
 * @param {*} payload
 */
function* GetReports({ payload, type }: ReportData): SagaIterator {
    try {
        const response = yield call(getAllReportApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                reportApiResponseSuccess(ReportActionTypes.GET_REPORTS, responseData, message, code, false, false)
            );
        } else {
            let msg = `An error while getting Report Listing!`;
            if (message) msg = message;
            yield put(reportApiResponseSuccess(ReportActionTypes.GET_REPORTS, responseData, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(reportApiResponseError(ReportActionTypes.GET_REPORTS, [], error, 404, true, false));
    }
}

/**
 * Fetch Service Reports
 * @param {*} payload
 */
function* GetServiceReports({ payload, type }: ReportData): SagaIterator {
    try {
        const response = yield call(getAllServiceReportApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;

        if (code === 200 && success) {
            yield put(
                reportApiResponseSuccess(
                    ReportActionTypes.GET_SERVICE_REPORT,
                    responseData,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Service Report Listing!`;
            if (message) msg = message;
            yield put(
                reportApiResponseSuccess(ReportActionTypes.GET_SERVICE_REPORT, responseData, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(reportApiResponseError(ReportActionTypes.GET_SERVICE_REPORT, [], error, 404, true, false));
    }
}

/**
 * Fetch Sales Reports
 * @param {*} payload
 */
function* GetSalesReports({ payload, type }: ReportData): SagaIterator {
    try {
        const response = yield call(getAllSalesReportApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;

        if (code === 200 && success) {
            yield put(
                reportApiResponseSuccess(ReportActionTypes.GET_SALES_REPORT, responseData, message, code, false, false)
            );
        } else {
            let msg = `An error while getting Sales Report Listing!`;
            if (message) msg = message;
            yield put(
                reportApiResponseSuccess(ReportActionTypes.GET_SALES_REPORT, responseData, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(reportApiResponseError(ReportActionTypes.GET_SALES_REPORT, [], error, 404, true, false));
    }
}

/**
 * Fetch Validate Report
 * @param {*} payload
 */
function* GetValidateReport({ payload, type }: ReportData): SagaIterator {
    try {
        const response = yield call(getValidateReportApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                reportApiResponseSuccess(ReportActionTypes.GET_VALIDATE_REPORT, data, message, code, false, false)
            );
        } else {
            let msg = `An error while getting Report!`;
            if (message) msg = message;
            yield put(reportApiResponseSuccess(ReportActionTypes.GET_VALIDATE_REPORT, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(reportApiResponseError(ReportActionTypes.GET_VALIDATE_REPORT, [], error, 404, true, false));
    }
}

/**
 * Fetch Observation Reports
 * @param {*} payload
 */
function* GetObservationReports({ payload, type }: ReportData): SagaIterator {
    try {
        const response = yield call(getObservationReportApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;

        if (code === 200 && success) {
            yield put(
                reportApiResponseSuccess(
                    ReportActionTypes.GET_OBSERVATION_REPORT,
                    responseData,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Observation Report Listing!`;
            if (message) msg = message;
            yield put(
                reportApiResponseSuccess(ReportActionTypes.GET_OBSERVATION_REPORT, responseData, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(reportApiResponseError(ReportActionTypes.GET_OBSERVATION_REPORT, [], error, 404, true, false));
    }
}

export function* watchGetReport() {
    yield takeEvery(ReportActionTypes.GET_REPORT, GetReport);
}

export function* watchGetReports() {
    yield takeEvery(ReportActionTypes.GET_REPORTS, GetReports);
}

export function* watchGetServiceReports() {
    yield takeEvery(ReportActionTypes.GET_SERVICE_REPORT, GetServiceReports);
}

export function* watchGetSalesReports() {
    yield takeEvery(ReportActionTypes.GET_SALES_REPORT, GetSalesReports);
}

export function* watchAddReport() {
    yield takeEvery(ReportActionTypes.ADD_REPORT, AddReport);
}

export function* watchEditReport(): any {
    yield takeEvery(ReportActionTypes.EDIT_REPORT, EditReport);
}

export function* watchGetValidateReport(): any {
    yield takeEvery(ReportActionTypes.GET_VALIDATE_REPORT, GetValidateReport);
}

export function* watchGetObservationReport(): any {
    yield takeEvery(ReportActionTypes.GET_OBSERVATION_REPORT, GetObservationReports);
}

function* reportSaga() {
    yield all([
        fork(watchGetReport),
        fork(watchAddReport),
        fork(watchEditReport),
        fork(watchGetReports),
        fork(watchGetValidateReport),
        fork(watchGetServiceReports),
        fork(watchGetSalesReports),
        fork(watchGetObservationReport),
    ]);
}

export default reportSaga;
